module.exports = __webpack_public_path__ + "static/media/icon_8.83428cb9.svg";